import { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { setProject, setConfig, setUsers } from '../obj/pscState'
import Checkbox from '../components/psc/lib/Checkbox'

import useAuthentication from '../hooks/useAuthentication';
import useQualityContents from '../hooks/useQualityContents';
import useBrowserTabTitle from '../hooks/useBrowserTabTitle';

const Login = () => {
    useBrowserTabTitle('Login')

    const dispatch = useDispatch()
    const navigate = useNavigate()
    
    const [error, setError] = useState(false)
    const [rememberMe, setRememberMe] = useState(false)
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [verificationCode, setVerificationCode] = useState('')

    const { reloadQualityContents } = useQualityContents();

    const {
        currentUser,
        authenticate,
        authenticate2FA,
        requires2FA,
    } = useAuthentication();

    const redirectUrl = useMemo(() => {
        const query = new URLSearchParams(location.search)
        return query.get('redirect') || ''
    }, [location.search]);
    
    const fetchCurrentUserData = () => {
        fetch('/v0/projects/' + currentUser.current_project_id, { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                console.log('Login: setProject')
                dispatch(setProject(json.result))
            })
            .catch(error => console.log("Login getCurrentProject error", error));

        fetch('/v0/config', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                dispatch(setConfig(json))
            })
            .catch(error => console.log("Login getConfig error", error));

        fetch('/v0/users', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                dispatch(setUsers(json.results))
            })
            .catch(error => console.log("Login getUsers error", error));
        
        reloadQualityContents();

        if(redirectUrl !== '') {
            window.location.href = redirectUrl;
            
        } else {
            navigate('/main');
        }
    }

    useEffect(() => {
        if(currentUser?.id && currentUser.id > 0) {
            fetchCurrentUserData();
        }
    }, [currentUser?.id])

    const handleSubmit2FA = async (event) => {
        event.preventDefault();

        setError(false);
        try {
            await authenticate2FA({
                email,
                password,
                rememberMe,
                verificationCode,
            });
        } catch (error) {
            console.log(error)
            setError(true);
        }
    }

    const handleSubmit = async (event) => {
        event?.preventDefault();

        setError(false);
        try {
            await authenticate({
                email,
                password,
                rememberMe,
            });
        } catch (error) {
            console.log(error)
            setError(true);
        }
    };

    return (
        <div className="wrapper wrapper-content animated fadeInRight">
            <div className="row">
                <div className="col-lg-12">
                    <div className="text-center m-t-lg m-b-sm">
                        <h1>Welcome to GNC Go</h1>
                        <small>Please sign in below</small>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-3"></div>
                <div className="col-lg-6">
                    <div className="ibox float-e-margins">
                        <div className="ibox-content">
                            {requires2FA ? (
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h3 className="m-t-none m-b">Two Factor Authentication</h3>
                                        {error && <div className="alert alert-danger">Invalid Verification Code</div>}
                                        <form autoComplete="off" onSubmit={handleSubmit2FA}>
                                            <div className="form-group">
                                                <label>Verification Code</label>
                                                <input
                                                    name="verification_code"
                                                    type="text"
                                                    autoComplete="off"
                                                    placeholder="Enter verification code"
                                                    className="form-control"
                                                    value={verificationCode}
                                                    onChange={(e) => setVerificationCode(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <button
                                                    className="btn btn-sm btn-primary pull-right m-t-n-xs"
                                                    type="submit"
                                                >
                                                    Log in
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <h3 className="m-t-none m-b">Sign in</h3>
                                    {error && <div className="alert alert-danger">Login failed</div>}
                                    <form className="form" onSubmit={handleSubmit}>
                                        <div className="form-group">
                                            <label>Email</label>
                                            <input
                                                name="email"
                                                aria-label="Email"
                                                type="email"
                                                placeholder="Enter email"
                                                className="form-control"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Password</label>
                                            <input
                                                name="password"
                                                aria-label="Password"
                                                type="password"
                                                placeholder="Password"
                                                className="form-control"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group form-check-group">
                                            <Checkbox
                                                id="remember_me"
                                                name="remember_me"
                                                isChecked={rememberMe}
                                                onChange={() => setRememberMe(!rememberMe)}
                                            />
                                            <label style={{ fontWeight: 'normal' }} htmlFor="remember_me">
                                                Remember me
                                            </label>
                                        </div>
                                        <div className="form-group form-submit-group">
                                            <Link to="/forgot_password" role="link">
                                                Forgotten your password?
                                            </Link>

                                            <button
                                                className="btn btn-mr btn-primary pull-right m-t-n-xs"
                                                type="submit"
                                                role="button"
                                            >
                                                Log in
                                            </button>
                                        </div>
                                    </form>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div className="col-lg-3"></div>
            </div>
        </div>
    );
};

export default Login
